import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'antd/dist/reset.css';
import './index.css';
import { logger } from './services/logger.client';
import { initSentry } from './services/sentry.client';
import AppWithTheme from './AppWithTheme';

// Initialize Sentry before React renders (ADR-053)
initSentry();

logger.info('main.tsx: About to render the React application.');

ReactDOM.createRoot(document.getElementById('react-root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppWithTheme />
    </BrowserRouter>
  </React.StrictMode>,
);

document.dispatchEvent(new CustomEvent('react-ready'));